import { useForm } from "@tanstack/react-form";
import { z } from "zod";
import { UIKit } from "@/shared/ui";
import type { ExportSettings } from "../types";

const exportSettingsSchema = z.object({
	includeElevations: z.boolean(),
	includeDimensions: z.boolean(),
});

interface ExportOptionsModalProps {
	onClose: () => void;
	onExport: (settings: ExportSettings) => void;
}

/** Диалог параметров перед созданием векторного PDF рабочего чертежа. */
export const ExportOptionsModal = ({ onClose, onExport }: ExportOptionsModalProps) => {
	const form = useForm({
		defaultValues: {
			includeElevations: false,
			includeDimensions: false,
		},
		validators: { onChange: exportSettingsSchema },
		onSubmit: ({ value }) => onExport(value),
	});

	return (
		<UIKit.Modal ariaLabel="Параметры экспорта PDF" className="p-5 md:max-w-md" onClose={onClose}>
			<UIKit.Text size="xl">Экспорт PDF</UIKit.Text>
			<form className="mt-5 space-y-5" action={() => form.handleSubmit()}>
				<UIKit.FormField form={form} name="includeDimensions">
					{(field) => (
						<UIKit.Checkbox
							checked={field.state.value}
							onChange={(checked) => field.handleChange(checked)}
							className="cursor-pointer items-start gap-3 text-sm text-ink"
							inputClassName="mt-0.5 size-4 accent-accent"
							label="Добавить лист «Размеры»"
						/>
					)}
				</UIKit.FormField>
				<UIKit.FormField form={form} name="includeElevations">
					{(field) => (
						<UIKit.Checkbox
							checked={field.state.value}
							onChange={(checked) => field.handleChange(checked)}
							className="cursor-pointer items-start gap-3 text-sm text-ink"
							inputClassName="mt-0.5 size-4 accent-accent"
							label={
								<UIKit.Text as="span">
									Развёртки стен по помещениям
									<UIKit.Text as="span" size="small" className="mt-1 block text-ink">
										Добавить отдельный лист с развёрткой стен для каждого помещения.
									</UIKit.Text>
								</UIKit.Text>
							}
						/>
					)}
				</UIKit.FormField>
				<div className="flex justify-end gap-2">
					<UIKit.Button type="button" onClick={onClose}>
						Отмена
					</UIKit.Button>
					<UIKit.Button className="border-accent bg-accent text-white" type="submit">
						Сохранить PDF
					</UIKit.Button>
				</div>
			</form>
		</UIKit.Modal>
	);
};
